<template>
  <div class="product_introduction">
    <div style="margin-top: 20px;" class="banner">
      <div class="left">
        <div style="font-family: cursive;" class="title_box">
          <div class="">
            <div class="fz52">让办公更<span style="color:#0088FE">轻松</span></div>
            <div class="fz52">让医疗管理更加智能</div>
          </div>
          <div style="margin-top: 20px;" class="small_title"><span style="color:#252E3E;">匠心打造的综合运营管理系统</span> </div>
          <div style="margin-top: 20px;" class="small_title"><el-button type="primary">免费试用</el-button></div>
        </div>
      </div>
    </div>
    <div>
      <!-- 新增单元块 -->
      <div class="new-unit-block">
        <p>ALL IN ONE</p>
        <p>医疗行政一体化，高效管理全掌控</p>
      </div>
    </div>

    <div :style="{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',paddingBottom: '50px' }">
      <div
        style="padding-top:50px;font-family: 'Source Han Sans CN', 'Source Han Sans CN'; font-weight: 500; font-size: 45px; color: #252E3E; text-align: center; font-style: normal; text-transform: none;">
        行政端介绍</div>
        <div
        style="padding-top:50px;font-family: 'Source Han Sans CN', 'Source Han Sans CN'; font-weight: 500; font-size: 32px; color: #252E3E; text-align: center; font-style: normal; text-transform: none;">
        高效运营各种工作场景，赋能医疗诊所管理</div>
        <div style="display: flex; justify-content: center; align-items: center; margin: auto; flex-wrap: wrap;width: 80%;">
          <div v-for="(item, index) in list" :key="index" class="cardItem" style="">
            <div style="text-align:center; padding-top: 20px;">
              <div><img style="height: 60px;" :src="item.img" alt=""></div>
              <div style="margin-left: 4px;">
                <div style="font-weight: 500; font-size: 18px; color: #252E3E;">{{ item.title }}</div>
                <div style="font-weight: 400; font-size: 12px; color: #A7ABB4;text-align:left;margin-top:20px">{{ item.txt }}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div :style="{ backgroundImage: `url(${bgImage1})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat',paddingBottom: '50px' }">
      <div style="padding:50px 70px;width: 45%;box-sizing: border-box;">
      <div style="font-weight: 400;font-size: 32px;color: #FFFFFF;margin-top:50px">财务全面管控</div>
        <div style="color: #fff;margin-top: 50px;display: flex;align-items: center;">
            <img src="../../../assets/1.png" alt="" srcset="" style="margin-right: 30px;height:40px">
            <div>
                <div style="font-weight: 400;font-size: 15px;color: #FFFFFF;">门诊收支全记录</div>
                <div style="font-weight: 400;font-size: 12px;color: #FFFFFF;margin-top:10px">诊所门诊的所有收入与支出，都能在系统中精准记录，确保每一笔财务数据清晰可查，为财务核算提供准确依据。</div>
            </div>
        </div>
        <div style="color: #fff;margin-top: 50px;display: flex;align-items: center;">
            <img src="../../../assets/2.png" alt="" srcset="" style="margin-right: 30px;height:40px">
            <div>
                <div style="font-weight: 400;font-size: 15px;color: #FFFFFF;">财务流程自动化</div>
                <div style="font-weight: 400;font-size: 12px;color: #FFFFFF;margin-top:10px">从费用报销、收款入账到财务报表生成，系统自动流转和处理，提高财务工作效率，降低出错概率，确保财务流程的规范性和透明度。</div>
            </div>
        </div>
        <div style="color: #fff;margin-top: 50px;display: flex;align-items: center;">
            <img src="../../../assets/3.png" alt="" srcset="" style="margin-right: 30px;height:40px">
            <div>
                <div style="font-weight: 400;font-size: 15px;color: #FFFFFF;">财务数据分析与预警</div>
                <div style="font-weight: 400;font-size: 12px;color: #FFFFFF;margin-top:10px">对门诊财务数据进行深度分析，生成各类财务报表和分析图表。设置财务预警指标，当出现异常收支或财务风险时，及时发出预警提示。</div>
            </div>
        </div>
      </div>
    </div>
    <div :style="{ backgroundImage: `url(${bgImage2})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat',paddingBottom: '50px' ,display:'flex','justify-content': 'flex-end'}">
      <div style="padding:50px 70px;width: 45%;box-sizing: border-box;">
        <div style="font-weight: 400;font-size: 32px;color: #FFFFFF;margin-top:50px">营销智慧赋能</div>
            <div style="color: #fff;margin-top: 50px;display: flex;align-items: center;">
                <img src="../../../assets/4.png" alt="" srcset="" style="margin-right: 30px;height:40px">
                <div>
                    <div style="font-weight: 400;font-size: 15px;color: #FFFFFF;">客户精准画像</div>
                    <div style="font-weight: 400;font-size: 12px;color: #FFFFFF;margin-top:10px">收集患者就诊信息、消费记录等数据，构建详细的客户画像，为精准营销提供数据支持，实现个性化的医疗服务推荐和营销活动推送。</div>
                </div>
            </div>
            <div style="color: #fff;margin-top: 50px;display: flex;align-items: center;">
                <img src="../../../assets/5.png" alt="" srcset="" style="margin-right: 30px;height:40px">
                <div>
                    <div style="font-weight: 400;font-size: 15px;color: #FFFFFF;">多渠道营销推广</div>
                    <div style="font-weight: 400;font-size: 12px;color: #FFFFFF;margin-top:10px">支持线上线下多种营销渠道，根据不同渠道特点，定制专属的营销内容和活动方案，扩大诊所知名度和影响力。</div>
                </div>
            </div>
            <div style="color: #fff;margin-top: 50px;display: flex;align-items: center;">
                <img src="../../../assets/6.png" alt="" srcset="" style="margin-right: 30px;height:40px">
                <div>
                    <div style="font-weight: 400;font-size: 15px;color: #FFFFFF;">营销效果评估与优化</div>
                    <div style="font-weight: 400;font-size: 12px;color: #FFFFFF;margin-top:10px">对门诊财务数据进行深度分析，生成各类财务报表和分析图表。设置财务预警指标，当出现异常收支或财务风险时，及时发出预警提示。</div>
                </div>
            </div>
        </div>
    </div>
    <div :style="{ backgroundImage: `url(${bgImage3})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',padding: '50px' }">
      <div style="text-align:center">全方位自定义专属工作场景</div>
      <div style="text-align:center"><img style="height: 366px;margin-top:50px" src="@/assets/组5111@2x.png" alt=""></div>
    </div>
    <div :style="{ backgroundImage: `url(${bgImage4})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',padding: '20px' }">
 
      <div
        class="box"
        style=" ">
        <!-- 这里可以添加主题内容 -->
        <transition name="animate__animated animate__bounce" appear enter-active-class="animate__fadeInLeft">   
          <div
          class="box_title"
          style="">
         <img style="height:31px" src="@/assets/画板15@2x.png" alt=""> 办公自动化</div>
        </transition>
        <div class="box_content_txt" style="">系统涵盖了日常办公的各个方面，如流程审批、通知发布、任务分配等，实现办公流程的自动化，提高办公效率</div>

        <div class="box_content" >
          <div>
            <div>
              <div style="display:flex;align-items:center;justify-content:center">
                <img style="height:31px;" src="@/assets/画板1@2x.png" alt="">
                <span style="font-weight: bold;font-size: 18px;color: #252E3E;margin-left:10px">网页端</span>
              </div>
              <img style="height: 229px; width:100%;margin-top:14px" src="@/assets/xzBg.png" alt="">
            </div>
          </div>
          <div style="margin-left: 20px;">
            <div>
              <div style="display:flex;align-items:center;justify-content:center">
                <img style="height:31px;" src="@/assets/画板17@2x.png" alt="">
                <span style="font-weight: bold;font-size: 18px;color: #252E3E;margin-left:10px">小程序</span>
              </div>
              <img style="height: 229px; width:170px;margin-top:14px" src="@/assets/xzBg1.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
      <div>
        <!-- 新增单元块 -->
        <div class="new-unit-block">
          <p>为医疗诊所的高效管理与优质服务</p>
          <p>提供全方位支撑</p>
        </div>
      </div>
    <div :style="{ backgroundImage: `url(${bgImage3})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',padding: '50px',}">
      <div style="display: flex; justify-content: center; align-items: center; margin: auto; flex-wrap: wrap;width: 80%;">
        <div v-for="(item, index) in listF" :key="index" class="cardItem" >
          <div style="text-align:center; padding-top: 20px;">
            <div><img style="height: 60px;" :src="item.img" alt=""></div>
            <div style="margin-left: 4px;">
              <div style="font-weight: 500; font-size: 18px; color: #252E3E;">{{ item.title }}</div>
              <div style="font-weight: 400; font-size: 12px; color: #A7ABB4;text-align:left;margin-top:20px">{{ item.txt }}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center;margin-top:100px;font-size: 32px;">克里特·易康，众多医疗诊所的好管家</div>
      <div style="text-align: center;margin-top:36px"><img style="text-align: center;width:99px;height:32px" src="@/assets/组14@2x.png" alt=""></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList:[
        {title:'克里特·易康医疗管理系统对哪些诊所适用呢？',txt:'适用于西医、中医、全科、口腔、眼视光、儿科、医美等各类型诊所，同时也适用于中小个体诊所、大型诊所、连锁诊所、社区医院等多种规模的医疗机构。界面友好，轻松上手，功能强大。'},
        {title:'这个产品对我诊所里哪些角色适用呢？',txt:'克里特·易康医疗管理系统为诊所所有角色提供全面支持：患者便捷挂号，医生快速书写病历处方，护士高效执行医嘱，检验人员顺畅安排化验，药房人员轻松管理药品进销存，管理者实时掌握经营数据，营销人员轻松策划活动。'},
        {title:'安装方便吗？',txt:'安装克里特·易康医疗管理系统就像安装手机App一样简单。作为全新一代的基层医疗系统，您无需购买服务器，不用聘请技术人员，也不用经历繁琐的安装过程，只需在线注册，即可快速开始使用。另外我们也有小程序可以操作，非常方便。'},
        {title:'系统会持续更新吗？如果我有新需求怎么支持呢？',txt:'不同于传统软件一次性安装的方式，克里特·易康医疗管理系统是自动持续更新，无需手动操作。我们会通过各种渠道倾听诊所需求，提出切实解决问题的方案，确保用户问题即时解决。'},
      ],
      list:[
        {title:'运营看板',txt:'直观展示运营数据界面，关键指标一目了然，实时更新数据看板',img:require('@/assets/xzIco (8).png')},
        {title:'统计报表',txt:'提供数据资料整理，助力管理者做出数据驱动的决策',img:require('@/assets/xzIco (7).png')},
        {title:'排班管理',txt:'先进的算法优化医师排班，确保患者得到及时的诊疗服务。',img:require('@/assets/xzIco (6).png')},
        {title:'收银管理',txt:'自动计算费用，支持多种支付方式以及清晰的收银记录',img:require('@/assets/xzIco (5).png')},
        {title:'智能药房',txt:'快速发放药品，根据处方自动配药一键打印处方和药品信息',img:require('@/assets/xzIco (4).png')},
        {title:'随访管理',txt:'记录随访内容，设置随访计划，自动提醒随访',img:require('@/assets/xzIco (3).png')},
        {title:'线上咨询',txt:'记录咨询内容，自动标记咨询状态记录患者的健康信息',img:require('@/assets/xzIco (2).png')},
        {title:'科室管理',txt:'集中管理科室信息，快速检索，多种条件筛选。',img:require('@/assets/xzIco (1).png')}
      ],
      listF:[
        {title:'数字化，全域协同高效',txt:'众多协同流程触发即用，覆盖"人财物事"全场景，让协同更高效',img:require('@/assets/组5114@2x.png')},
        {title:'平台化，应用扩展敏捷',txt:'低代码，可建模、可集成、可开发；性能可伸缩、应用可扩展；适配国产化，安全可靠',img:require('@/assets/组5255@2x.png')},
        {title:'智能化，效能自动提升',txt:'支持智能AI对话、智能助手、智能报销等功能，适配多款智能硬件，自动化水平高',img:require('@/assets/组5254@2x.png')},
        {title:'一体化，医疗行政一体',txt:'为医疗诊所的高效管理与优质服务提供全方位支撑，引领诊所管理步入智能化新纪元。',img:require('@/assets/组5253@2x.png')}
      ],
      scrollPosition: 0,
      // 动态加载图片
      bgImage: require('@/assets/组5102@2x.png'),
      bgImage1: require('@/assets/组5386@2x.png'),
      bgImage2: require('@/assets/组5387@2x.png'),
      bgImage3: require('@/assets/组5392@2x.png'),
      bgImage4: require('@/assets/组5391@2x.png'),
      bgImage5: require('@/assets/组5317@2x.png'),
      bgImage6: require('@/assets/矩形896@2x.png'),
      bgImage7: require('@/assets/组10@2x.png'),
      bgImage8: require('@/assets/组13@2x.png'),
    };
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.scrollPosition = window.scrollY;
    });
  }
};
</script>

<style lang="scss" scoped>
.product_introduction {
  .fz52{
    font-size: 52px;
  }
  .small_title{
    font-size: 32px;
  }
  .box{
    margin: 50px auto;
    background:#fff;
    width: 45%;
    border-radius: 2%; 
    height:431px;
    .box_title{
      margin-left:50px;
      width: 40%;
      font-family: 'Source Han Sans CN', 'Source Han Sans CN';
      font-weight: 500;
      font-size: 29px; color: #252E3E;
      font-style: normal; text-transform: none;padding:30px
    }
    .box_content_txt{
      margin-left:80px;
      margin-top:11px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 11px;
      color: #7D828D;
    }
    .box_content{
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top:23px;
    }
  }
  .cardItem {
    width: 20%; 
    height: 189px;
    background: #fff; 
    border-radius: 2%; 
    padding: 10px; 
    margin-top:50px;
    margin-right:20px;
  }
  .banner {
    min-width: 1024px;
    width: 100%;
    height: 20rem;
    background-image: url('../../../assets/组5299@2x.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 46%;
      height: 70%;
      //background: red;
      padding-left: 2.8rem;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .title_box {
        height: 4.1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        display: flex;

        .image-and-text {
          display: flex; // 使用 Flexbox 来管理子元素的布局
          align-items: center; // 垂直居中对齐子元素
        }

        .kelete {
          width: 60%;
          margin-top: 4px;
        }

        .big_title {
          font-weight: 600;
          font-size: 1.6rem;
          color: #000000;
        }

        .small_title {
          font-weight: 500;
          font-size: 0.82rem;
          color: #000000;
        }

      }
    }
  }

  // 新增单元块样式
  .new-unit-block {
    font-family: 'Source Han Sans CN', 'Source Han Sans CN';
    font-weight: 500;
    font-size: 32px;
    color: #252E3E;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 20px;
  }

  .product_introduction_contact {
    min-width: 1024px;
    width: 100%;
    padding-top: 3.2rem;
    padding-bottom: 4rem;
    color: #333333;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F4F3F3;

    .image-and-text {
      display: flex; // 使用 Flexbox 来管理子元素的布局
      align-items: center; // 垂直居中对齐子元素

      .keletebg1 {
        width: 100px;
        margin-right: 10px;
        margin-bottom: 15px;
      }
    }

    .title {
      margin-bottom: 0.6rem;
      font-size: 0.88rem;
      font-weight: 600;
    }

    .subtitle {
      font-size: 0.56rem;
      color: #999999;
      margin-bottom: 2.4rem;
    }

    .highlights {
      width: 70%;
      display: flex;
      justify-content: space-between;

      .highlights_item {
        width: 26%;
        height: 11.6rem;
        padding: 0.8rem 0.8rem 0px 0.8rem;
        background: #e9eeff;
        display: flex;
        flex-direction: column;
        align-items: center;

        .img1 {
          width: 1.8rem;
          height: 1.6rem;
          background-image: url('../../../assets/productIntroduction2.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-bottom: 0.8rem;
        }

        .img2 {
          width: 1.6rem;
          height: 1.8rem;
          background-image: url('../../../assets/productIntroduction3.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-bottom: 0.6rem;
        }

        .img3 {
          width: 2rem;
          height: 1.9rem;
          background-image: url('../../../assets/productIntroduction4.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-bottom: 0.6rem;
        }

        .main_title {
          font-size: 0.72rem;
          font-weight: 600;
          margin-bottom: 0.8rem;
        }

        .main_container {
          font-size: 0.64rem;
          color: #999999;
          line-height: 1rem;
        }
      }
    }
  }

  .product_introduction_application_architecture {
    width: 100%;
    padding-top: 3.2rem;
    padding-bottom: 4.8rem;
    color: #333333;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 1024px;

    .image-and-text {
      display: flex; // 使用 Flexbox 来管理子元素的布局
      align-items: center; // 垂直居中对齐子元素

      .keletebg1 {
        width: 120px;
        margin-right: 10px;
        margin-bottom: 12px;
      }

      .title {
        margin-bottom: 0.6rem;
        font-size: 0.88rem;
        font-weight: 600;
      }
    }


    .subtitle {
      font-size: 0.56rem;
      color: #999999;
      margin-bottom: 1.2rem;
    }

    .bg {
      width: 85%;
      height: 27.52rem;
      background-image: url('../../../assets/productIntroduction16.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }

  .product_features {
    min-width: 1024px;
    width: 100%;
    padding-top: 2.4rem;
    padding-bottom: 3.2rem;
    color: #333333;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 0.88rem;
      font-weight: 600;
      margin-bottom: 1.6rem;
    }

    .container {
      width: 85%;
      display: flex;

      .explain {
        width: 8rem;
        font-size: 0.64rem;
        color: #999999;
        margin-right: 2rem;
        line-height: 1rem;
      }

      .image1 {
        width: 80%;
        height: 23.2rem;
        background-image: url('../../../assets/productIntroduction5.png');
        background-size: 100% 110%;
        background-repeat: no-repeat;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;
      }

      .image2 {
        width: 80%;
        height: 23.2rem;
        background-image: url('../../../assets/productIntroduction6.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;
      }

      .image3 {
        width: 80%;
        height: 23.2rem;
        background-image: url('../../../assets/productIntroduction7.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;
      }

      .image4 {
        width: 80%;
        height: 23.2rem;
        background-image: url('../../../assets/productIntroduction8.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;
      }

      .image5 {
        width: 80%;
        height: 23.2rem;
        background-image: url('../../../assets/productIntroduction9.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;
      }

      .image6 {
        width: 80%;
        height: 23.2rem;
        background-image: url('../../../assets/productIntroduction10.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;
      }

      .image7 {
        width: 80%;
        height: 23.2rem;
        background-image: url('../../../assets/productIntroduction11.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;
      }

      .image8 {
        width: 80%;
        height: 23.2rem;
        background-image: url('../../../assets/productIntroduction12.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;
      }

      .image_list {
        width: 80%;
        height: 27.2rem;
        display: flex;
        border-radius: 20px;
        box-shadow: 0 0 20px #f4f4f5;

        .image_list_item1 {
          margin-right: 1.6rem;
          width: 25%;
          height: 100%;
          background-image: url('../../../assets/productIntroduction13.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .image_list_item2 {
          margin-right: 1.6rem;
          width: 30%;
          height: 100%;
          background-image: url('../../../assets/productIntroduction14.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .image_list_item3 {
          margin-right: 1.6rem;
          width: 30%;
          height: 100%;
          background-image: url('../../../assets/productIntroduction15.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
  }
}

/* 专门针对移动端的样式适配 */
@media screen and (max-width: 768px) {
  .fz52{
    font-size: 22px !important;
  }
  .small_title{
    font-size: 12px !important;
  }
  .box{
    margin: 50px auto;
    background:#fff;
    width: 100% !important;
    border-radius: 2%; 
    height:100% !important;
    .box_title{
      margin-left:50px;
      width: 100% !important;
      font-family: 'Source Han Sans CN', 'Source Han Sans CN';
      font-weight: 500;
      font-size: 29px; color: #252E3E;
      font-style: normal; text-transform: none;padding:30px
    }
    .box_content_txt{
      margin-left:0px !important;
      margin-top:11px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 11px;
      color: #7D828D;
    }
    .box_content{
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      align-items: center;
      margin-top:23px;
    }
  }
  .product_introduction {
    /* 整体容器样式 */
    width: 100%;
    overflow-x: hidden;
    .cardItem {
      width: 80%; 
      height: 189px;
      background: #fff; 
      border-radius: 2%; 
      padding: 10px; 
      margin-top:50px;
      margin-right:20px;
    }
    /* 头部banner区域 */
    .banner {
      min-width: auto;
      height: auto;
      min-height: 180px;
      padding: 25px 15px;
      background-size: cover;
      background-position: center;
      
      .left {
        width: 100%;
        padding-left: 0;
        align-items: center;
        text-align: left;
        
        .title_box {
          height: auto;
          width: 100%;
          
          div div[style*="font-size:52px"] {
            font-size: 24px !important;
            line-height: 1.4;
            margin-bottom: 8px !important;
          }
          
          .small_title span[style*="font-size:32px"] {
            font-size: 16px !important;
            display: block !important;
            margin-top: 12px !important;
            line-height: 1.4;
          }
          
          /* 按钮优化 */
          div[style*="margin-top: 20px;"] {
            margin-top: 15px !important;
            
            .el-button {
              font-size: 14px !important;
              padding: 8px 24px !important;
              width: 85% !important;
              max-width: 180px !important;
              border-radius: 20px !important;
            }
          }
        }
      }
    }
    
    /* 新单元块样式 */
    .new-unit-block {
      padding: 15px;
      font-size: 20px;
      margin: 15px 0;
      background: #f8f9fa;
      border-radius: 8px;
      
      p {
        margin: 6px 0;
        line-height: 1.4;
      }
    }
    
    /* 背景区块统一处理 */
    [style*="backgroundImage"] {
      background-attachment: scroll;
      background-position: center;
      background-size: cover;
      padding: 25px 15px !important;
    }
    
    /* 标题样式调整 */
    [style*="font-size: 45px"] {
      font-size: 22px !important;
      padding-top: 20px !important;
      line-height: 1.4 !important;
      margin-bottom: 12px !important;
    }
    
    [style*="font-size: 32px"] {
      font-size: 18px !important;
      padding-top: 15px !important;
      line-height: 1.4 !important;
      margin-bottom: 15px !important;
    }
    
    /* 功能卡片区域 */
    [style*="display: flex; justify-content: center; align-items: center; margin: auto; flex-wrap: wrap"] {
      width: 100% !important;
      padding: 0;
      flex-direction: column !important;
    }
    
    /* 行政端介绍单元优化 */
    [style*="backgroundImage: `url(${bgImage})`"] {
      padding-bottom: 30px !important;
      
      /* 卡片容器 */
      [style*="display: flex; justify-content: center; align-items: center; margin: auto; flex-wrap: wrap;width: 80%;"] {
        width: 95% !important;
        padding: 0 10px;
      }
      
      /* 行政端卡片样式优化 */
      [style*="width: 20%; height: 189px; background: #fff; border-radius: 2%; padding: 10px; margin-top:50px"] {
        width: 100% !important;
        height: auto !important;
        min-height: 160px !important;
        margin: 15px 0 !important;
        margin-right: 0 !important;
        padding: 20px !important;
        border-radius: 12px !important;
        box-shadow: 0 3px 10px rgba(0,0,0,0.1) !important;
        
        [style*="text-align:center; padding-top: 20px;"] {
          padding: 0 !important;
          
          div:first-child {
            margin-bottom: 15px !important;
          }
          
          img[style*="height: 60px"] {
            height: 50px !important;
            margin-bottom: 15px !important;
          }
          
          [style*="margin-left: 4px;"] {
            margin: 0 !important;
            width: 100% !important;
            
            [style*="font-size: 18px; color: #252E3E;"] {
              font-size: 18px !important;
              margin: 0 0 12px !important;
              font-weight: 600 !important;
              text-align: center !important;
            }
            
            [style*="font-size: 12px; color: #A7ABB4;text-align:left;margin-top:20px"] {
              font-size: 14px !important;
              line-height: 1.6 !important;
              text-align: center !important;
              margin-top: 10px !important;
              color: #555 !important;
            }
          }
        }
      }
    }
  }
}

/* 小屏手机适配 */
@media screen and (max-width: 480px) {
  .product_introduction {
    .banner {
      min-height: 160px;
      padding: 20px 12px;
      
      .left .title_box {
        div div[style*="font-size:52px"] {
          font-size: 20px !important;
        }
        
        .small_title span[style*="font-size:32px"] {
          font-size: 14px !important;
        }
        
        /* 按钮优化 */
        div[style*="margin-top: 20px;"] {
          margin-top: 12px !important;
          
          .el-button {
            font-size: 13px !important;
            padding: 7px 20px !important;
            width: 85% !important;
          }
        }
      }
    }
    
    .new-unit-block {
      font-size: 16px;
      padding: 12px;
      
      p {
        margin: 4px 0;
      }
    }
    
    /* 标题样式调整 */
    [style*="font-size: 45px"] {
      font-size: 18px !important;
      padding-top: 15px !important;
    }
    
    [style*="font-size: 32px"] {
      font-size: 16px !important;
      padding-top: 12px !important;
    }
    
    /* 行政端卡片样式优化 */
    [style*="width: 20%; height: 189px; background: #fff; border-radius: 2%; padding: 10px; margin-top:50px"] {
      min-height: 150px !important;
      padding: 15px !important;
      
      [style*="text-align:center; padding-top: 20px;"] {
        img[style*="height: 60px"] {
          height: 40px !important;
          margin-bottom: 10px !important;
        }
        
        [style*="margin-left: 4px;"] {
          [style*="font-size: 18px; color: #252E3E;"] {
            font-size: 16px !important;
            margin: 0 0 8px !important;
          }
          
          [style*="font-size: 12px; color: #A7ABB4;text-align:left;margin-top:20px"] {
            font-size: 13px !important;
            margin-top: 8px !important;
          }
        }
      }
    }
  }
}

/* 超小屏幕设备适配 */
@media screen and (max-width: 360px) {
  .product_introduction {
    .banner {
      min-height: 140px;
      padding: 15px 10px;
      
      .left .title_box {
        div div[style*="font-size:52px"] {
          font-size: 16px !important;
        }
        
        .small_title span[style*="font-size:32px"] {
          font-size: 12px !important;
        }
        
        /* 按钮优化 */
        div[style*="margin-top: 20px;"] {
          margin-top: 10px !important;
          
          .el-button {
            font-size: 12px !important;
            padding: 6px 16px !important;
            width: 90% !important;
          }
        }
      }
    }
    
    .new-unit-block {
      font-size: 14px;
      padding: 10px;
    }
    
    /* 标题统一进一步缩小 */
    [style*="font-size: 45px"] {
      font-size: 16px !important;
    }
    
    [style*="font-size: 32px"] {
      font-size: 14px !important;
    }
    
    /* 所有文本内容字体进一步缩小 */
    [style*="font-size: 18px; color: #252E3E"] {
      font-size: 14px !important;
    }
    
    [style*="font-size: 12px; color: #A7ABB4"],
    [style*="font-size: 12px;color: #FFFFFF"] {
      font-size: 11px !important;
    }
    
    [style*="font-size: 15px;color: #FFFFFF"] {
      font-size: 13px !important;
    }
    
    /* 行政端卡片样式优化 */
    [style*="width: 20%; height: 189px; background: #fff; border-radius: 2%; padding: 10px; margin-top:50px"] {
      min-height: 140px !important;
      padding: 12px !important;
      
      [style*="text-align:center; padding-top: 20px;"] {
        img[style*="height: 60px"] {
          height: 35px !important;
          margin-bottom: 8px !important;
        }
        
        [style*="margin-left: 4px;"] {
          [style*="font-size: 18px; color: #252E3E;"] {
            font-size: 15px !important;
            margin: 0 0 6px !important;
          }
          
          [style*="font-size: 12px; color: #A7ABB4;text-align:left;margin-top:20px"] {
            font-size: 12px !important;
            margin-top: 6px !important;
          }
        }
      }
    }
  }
}

/* 横屏模式优化 */
@media screen and (max-width: 900px) and (orientation: landscape) {
  .product_introduction {
    .banner {
      min-height: 120px;
      padding: 15px;
      
      .left .title_box {
        div div[style*="font-size:52px"] {
          font-size: 18px !important;
        }
      }
    }
    
    /* 行政端卡片在横屏模式下使用两列布局 */
    [style*="backgroundImage: `url(${bgImage})`"] {
      [style*="display: flex; justify-content: center; align-items: center; margin: auto; flex-wrap: wrap;width: 80%;"] {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: wrap !important;
        justify-content: space-between !important;
      }
      
      [style*="width: 20%; height: 189px; background: #fff; border-radius: 2%; padding: 10px; margin-top:50px"] {
        width: 48% !important;
        margin: 10px 1% !important;
      }
    }
  }
}
</style>